﻿import {
    appendQueryParameters,
    fetchBaseQueryWrapper,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

interface ISearchInitiativesQueryParams {
    sortByLaunchDateDescending: boolean | null | undefined;
    status: string | null | undefined;
    productCategoryIds: (string | null)[] | null | undefined;
    projectTypeIds: (string | null)[] | null | undefined;
    page: number | null | undefined;
    pageSize: number | null | undefined;
}

export interface IInitiativeProjectType {
    publicId: string;
    name: string;
    order: number | null;
}

export interface IInitiativeFilterableColumnOptions {
    initiativeStatusOptions: { id: string; name: string }[];
    productCategoryOptions: { id: string; name: string }[];
    projectTypeOptions: { id: string; name: string }[];
}

export const initiativesApi = createApi({
 reducerPath: "initiativesApi",
 baseQuery: fetchBaseQueryWrapper({ path: "initiatives" }),
    endpoints: (build) => ({
        createInitiative: build.mutation({
            query: (command) => ({
                url: "",
                method: "POST",
                body: command,
            }),
            transformResponse: ({ data }) => data,
        }),
        updateInitiative: build.mutation({
            query: ({ initiativePublicId, ...command }) => ({
                url: `${initiativePublicId}`,
                method: "PUT",
                body: command,
            }),
            transformResponse: ({ data }) => data,
        }),
        uploadInitiativeDocument: build.mutation({
            query: ({ initiativePublicId, ...request }) => ({
                url: `${initiativePublicId}/documents`,
                method: "POST",
                body: request,
            }),
            transformResponse: ({ data }) => data,
        }),
        getInitiative: build.query({
            query: (id) => id,
            transformResponse: ({data}) => data,
        }),
        searchInitiatives: build.query({
            query: (queryParams: ISearchInitiativesQueryParams) =>
                appendQueryParameters("", {
                    status: queryParams.status,
                    sortByLaunchDateDescending: queryParams.sortByLaunchDateDescending,
                    projectTypeIds: queryParams.projectTypeIds,
                    productCategoryIds: queryParams.productCategoryIds,
                    page: queryParams.page,
                    pageSize: queryParams.pageSize,
                }),
        }),
        getInitiativeFilterableColumnOptions: build.query<IInitiativeFilterableColumnOptions, null>({
            query: () => "filterable-column-options",
            transformResponse: ({ data }) => data,
        }),
        getInitiativeDocuments: build.query({
            query: (initiativePublicId) => `${initiativePublicId}/documents`,
            transformResponse: ({ data }) => data,
        }),
        softDeleteInitiativeDocument: build.mutation({
            query: ({ initiativePublicId, documentPublicId }) => ({
                url: `${initiativePublicId}/documents/${documentPublicId}`,
                method: "DELETE",
          }),
          transformResponse: (response: { data: unknown } | null) => response?.data,
        }),
        getInitiativeProjectTypes: build.query<IInitiativeProjectType[], void>({
            query: () => "project-types",
            transformResponse: ({ data }) => data,
        }),
    }),
});

export const {
    useCreateInitiativeMutation,
    useUpdateInitiativeMutation,
    useUploadInitiativeDocumentMutation,
    useGetInitiativeQuery,
    useSearchInitiativesQuery,
    useGetInitiativeFilterableColumnOptionsQuery,
    useGetInitiativeDocumentsQuery,
    useSoftDeleteInitiativeDocumentMutation,
    useGetInitiativeProjectTypesQuery,
} = initiativesApi;